import { categories } from "@/mocks/news";

export default function Footer() {
  const scrollTo = (id: string) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-background-300 bg-background-200">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid gap-8 lg:grid-cols-[1.2fr_0.8fr_1fr_1fr]">
          <div>
            <a
              href="#top"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="flex items-center gap-2.5"
              aria-label="吃瓜51 首页"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-xl" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-black text-foreground-950">吃瓜51</span>
                <span className="mt-0.5 text-[10px] font-medium tracking-widest text-primary-600">
                  今日新瓜速递
                </span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-700">
              聚合全网热门事件与新鲜爆料的资讯平台，每日更新今日焦点话题，陪你把瓜吃得明明白白。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className="ri-weibo-fill" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className="ri-wechat-fill" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className="ri-bilibili-fill" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className="ri-youtube-fill" />
              </span>
            </div>
          </div>

          <div>
            <h3 className="flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-foreground-950">
              <i className="ri-compass-3-line text-primary-500" />
              快速导航
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-700">
              {[
                { id: "hot", t: "今日热榜" },
                { id: "feed", t: "新瓜速递" },
                { id: "topics", t: "热议话题" },
                { id: "special", t: "深度专题" },
                { id: "about", t: "关于吃瓜51" },
              ].map((l) => (
                <li key={l.id}>
                  <button
                    type="button"
                    onClick={() => scrollTo(l.id)}
                    className="transition-colors hover:text-primary-600"
                  >
                    {l.t}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-foreground-950">
              <i className="ri-grid-fill text-primary-500" />
              内容栏目
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-700">
              {categories
                .filter((c) => c.id !== "all")
                .map((c) => (
                  <li key={c.id}>
                    <button
                      type="button"
                      onClick={() => scrollTo("feed")}
                      className="flex items-center gap-2 transition-colors hover:text-primary-600"
                    >
                      <i className={`${c.icon} text-primary-500`} />
                      {c.name}
                    </button>
                  </li>
                ))}
            </ul>
          </div>

          <div>
            <h3 className="flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-foreground-950">
              <i className="ri-customer-service-2-line text-primary-500" />
              联系我们
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-foreground-700">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500" />
                <a href="mailto:hello@chigua51.com" className="transition-colors hover:text-primary-600">
                  hello@chigua51.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-500" />
                编辑部 7×24 在线更新
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => scrollTo("subscribe")}
                  className="flex items-center gap-1.5 whitespace-nowrap rounded-lg bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-send-plane-line" />
                  订阅 / 投稿
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-300">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-4 text-xs text-foreground-600 sm:flex-row md:px-6">
          <p>© {year} 吃瓜51 · 聚合公开资讯，理性吃瓜，快乐追热点。</p>
          <p className="flex items-center gap-2">
            内容基于公开信源整理
            <span className="text-background-500">|</span>
            <span className="text-foreground-700">专注今日新瓜速递</span>
          </p>
        </div>
      </div>
    </footer>
  );
}